module.exports = __webpack_public_path__ + "img/feature-05.2a470ba9.png";